import React from 'react';
import { AppBar, Toolbar, Typography, Box, useMediaQuery } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';

export default function AppBarHeader() {
  const today = dayjs().format('dddd, MMMM D, YYYY');
  const time = dayjs().format('h:mm A');
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: '#1976d2',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        zIndex: 1200
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: isSmall ? 'column' : 'row',
          gap: isSmall ? 0.5 : 0,
          py: isSmall ? 1 : 0
        }}
      >
        {/* Left Side: Welcome Message */}
        <Box sx={{ textAlign: isSmall ? 'center' : 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Welcome Admin
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            All systems running smoothly
          </Typography>
        </Box>

        {/* Right Side: Date and Time (hidden on small screens) */}
        {!isSmall && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CalendarTodayIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">{today}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AccessTimeIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">{time}</Typography>
            </Box>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}